import "../Team/Team.css";
import React from "react";
import MemberCard from "../../layouts/team/membercard";
import shreyansh from '../../assets/images/Shreyansh.jpg'
import soumen from '../../assets/images/Soumen.jpg'
import peiyu from '../../assets/images/Peiyu.jpg'
import jung from '../../assets/images/Jung Wei.png'
import pujaDe from '../../assets/images/PujaDe.jpg'
import yitingLu from '../../assets/images/YitingLu.jpg'
import bernard from '../../assets/images/Bernard.jpg'
import phanAnh from '../../assets/images/PhanAnh.jpg'
import jiaYu from '../../assets/images/JiaYu.jpg'
import nivey from '../../assets/images/Nivey.jpg'
import gabriella from '../../assets/images/Gabriella.jpg'

function Team() {

  const currentMembers = [
    {
      name: "Peiyu Yi",
      designation: "PhD (2025–present)",
      email: "PEIYU003@e.ntu.edu.sg",
      image: peiyu,
      education: [
        { degree: "M.S. Dalian University of Technology", advisor: "Prof. Qingwei Meng" },
      ],
      country: "https://flagcdn.com/w40/cn.png"
    },
    {
      name: "Soumen Ghosh",
      designation: "PhD (2025–present)",
      email: "SOUMEN002@e.ntu.edu.sg",
      image: soumen,
      education: [
        { degree: "M.S. Indian Institute of Technology, Guwahati", advisor: "Prof. Dipankar Srimani" },
      ],
      country: "https://flagcdn.com/w40/in.png"
    },
    {
      name: "Dr. Puja De",
      designation: "Postdoc (2026–present)",
      email: "puja.de@ntu.edu.sg",
      image: pujaDe,
      education: [
        { degree: "Ph.D. Indian Institute of Science Education and Research, Kolkata", advisor: "Prof. Sayam Sen Gupta" },
      ],
      country: "https://flagcdn.com/w40/in.png"
    },
    {
      name: "Yiting (Gloria) Lu",
      designation: "PhD (2026–present)",
      email: "YLU059@e.ntu.edu.sg",
      image: yitingLu,
      education: [
        { degree: "M.S. National University of Singapore", advisor: "Prof. Gloryn Chia" },
      ],
      country: "https://flagcdn.com/w40/cn.png"
    },
    {
      name: "Serasozapandian Karuppiah Thiruraamund Bernard",
      designation: "M.S. (2026–present)",
      email: "THIRURAA001@e.ntu.edu.sg",
      image: bernard,
      education: [
        { degree: "B.S. Nanyang Technological University", advisor: "" },
      ],
      country: "https://flagcdn.com/w40/sg.png"
    },
    {
      name: "Shreyansh Daga",
      designation: "Undergraduate (2025–present)",
      email: "DAGA0002@e.ntu.edu.sg",
      image: shreyansh,
      education: [
        { degree: "B.S. Nanyang Technological University (expected 2027)", advisor: "" }
      ],
      country: "https://flagcdn.com/w40/sg.png"
    },
    {
      name: "Phan Anh Dang",
      designation: "Undergraduate (2026–present)",
      email: "PHANANH001@e.ntu.edu.sg",
      image: phanAnh,
      education: [],
      country: "https://flagcdn.com/w40/vn.png"
    },
    {
      name: "Jia Yu Kueh",
      designation: "Undergraduate (2026–present)",
      email: "KUEH0004@e.ntu.edu.sg",
      image: jiaYu,
      education: [],
      country: "https://flagcdn.com/w40/sg.png"
    },
    {
      name: "Niveydithaa (Nivey) Saravanan",
      designation: "Undergraduate (2026–present)",
      email: "NI0003AN@e.ntu.edu.sg",
      image: nivey,
      education: [],
      country: "https://flagcdn.com/w40/sg.png"
    },
    {
      name: "Gabriella Iriawan",
      designation: "Undergraduate (2026–present)",
      email: "GIRIAWAN001@e.ntu.edu.sg",
      image: gabriella,
      education: [],
      country: "https://flagcdn.com/w40/id.png"
    },
  ];

  const alumni = [
    {
      name: "Jung Wei Ling",
      designation: "Undergraduate (2025–2026)",
      email: "LING0110@e.ntu.edu.sg",
      image: jung,
      education: [
        { degree: "B.S. Nanyang Technological University", advisor: "" }
      ],
      country: "https://flagcdn.com/w40/sg.png"
    },
  ];

  return (
    <div>
      <div className="team-grid">
        <div className="grid-text">
          <div className="publication-header" style={{ fontSize: "50px" }}>
            Team
          </div>
        </div>
        <div />
      </div>
      <div className="team-profile-section">
        <div className="header" style={{ marginBottom: "2rem" }}>
          <u>Current Members</u>
        </div>
        <div className="team-members-grid">
          {currentMembers.map((member, idx) => (
            <MemberCard key={idx} {...member} />
          ))}
        </div>

        <div className="header" style={{ marginTop: "3rem", marginBottom: "2rem" }}>
          <u>Alumni</u>
        </div>
        <div className="team-members-grid">
          {alumni.map((member, idx) => (
            <MemberCard key={idx} {...member} grayscale />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Team;